import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import Welcome from './components/Welcome';
import Dashboard from './components/Dashboard';
import Uploads from './components/Uploads';
import Chats from './components/Chats';
import Topics from './components/Topics';
import Builder from './components/Builder';
import Alignment from './components/Alignment';
import Profile from './components/Profile';
import Login from './components/Login';
import Register from './components/Register';
import Tools from './components/Tools';
import SecurityTerminal from './components/SecurityTerminal';
import Forum from './components/Forum';
import { UMAStatsProvider } from './components/UMAStatsContext';

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('uma_token'));
  const [showWelcome, setShowWelcome] = useState(true);

  useEffect(() => {
    setToken(localStorage.getItem('uma_token'));
  }, []);

  return (
    <Router>
      <UMAStatsProvider>
        {showWelcome ? (
          <Welcome token={token} onContinue={() => setShowWelcome(false)} />
        ) : !token ? (
          <Routes>
            <Route path="/login" element={<Login setToken={setToken} />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/register" />} />
          </Routes>
        ) : (
          <>
            <nav className="flex flex-col md:flex-row justify-between items-center border-b border-green-800 pb-1 px-1 pt-1 text-base font-mono text-green-300">
              <span className="flex text-xl text-white font-bold glitch-text">umaMANAGER [./CODExDIZ]</span>
              <div className="flex flex-wrap items-center gap-4 mt-6 md:mt-0">
                <Link to="/dashboard">Dashboard</Link>
                <Link to="/comms">Comms</Link>
                <Link to="/builder">Builder</Link>
                <Link to="/profile">Profile</Link>
                <Link to="/topics">Topics</Link>
                <Link to="/chats">Chats</Link>
                <Link to="/uploads">Uploads</Link>
                <Link to="/alignment">Alignment</Link>
                <span className="flex items-center gap-1">
                  <span className="text-green-400 ml-0">&rarr;</span>
                  <Link to="/tools" className="font-bold underline text-green-300">Tools</Link>
                  <span className="text-green-400 ml-0">&larr;</span>
                  <span className="text-green-400 ml-1">INJECTORS!</span>
                </span>
                <button
                  onClick={() => {
                    localStorage.removeItem('uma_token');
                    window.location.href = '/';
                  }}
                  className="hover:text-red-400 hover:border:red text-green-300 pr-6"
                  aria-label="Logout"
                >
                  <LogOut size={18} />
                </button>
              </div>
              <div className="fixed bottom-4 left-4 text-white-500 text-base opacity-50 z-10">[./CODExDIZ]
              </div>
              <div className="fixed bottom-4 right-4 text-white-500 text-base opacity-50 z-10">umaMANAGER v2.2
              </div>
            </nav>

            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/comms" element={<Forum />} />
              <Route path="/builder" element={<Builder />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/topics" element={<Topics />} />
              <Route path="/chats" element={<Chats />} />
              <Route path="/uploads" element={<Uploads />} />
              <Route path="/alignment" element={<Alignment />} />
              <Route path="/tools" element={<Tools />} />
              <Route path="/security" element={<SecurityTerminal />} />
            </Routes>
          </>
        )}
      </UMAStatsProvider>
    </Router>
  );
};

export default App;